import EventBus from '@/utils/eventBus.js'
import i18n from '@/plugins/i18n.js'
import { getTenantId } from '@/utils/helpers'

const errorMessage = 'session_expired'

function tenantId (axios) {
  axios.interceptors.request.use(
    request => {
      const tenantId = getTenantId()

      if (tenantId) {
        request.headers.tenantId = tenantId

        return request
      } else {
        throw new Error(errorMessage)
      }
    },
    error => {
      throw error
    }
  )
  axios.interceptors.response.use(
    response => response,
    async error => {
      if (error.message === errorMessage) {
        const store = await import('@/store/index.js')
        await store.default.dispatch('user/logout')
        EventBus.$emit('notify-with-message', i18n.t('apiResponses.errors.sessionExpired'), { flushQueue: true })
      }
      throw error
    }
  )
}

export default tenantId
